import Api from '@/api/api.js'

export default {

    saveGrossesseCpn(data) {
        const promise = Api().post('/save_grossesse_elements', data)
        return promise.then(response => response.data)
    },

    getGrossesseEnCours(consultation_id) {
        const promise = Api().get('/cpn/' + consultation_id + '/grossesse')
        return promise.then((response) => response.data)
    },

    getExamensPhysiquesEnCours(consultation_id) {
        const promise = Api().get('/cpn/' + consultation_id + '/examen_physique')
        return promise.then((response) => response.data)
    },

    getAllParamCpn() {
        const promise = Api().get('/all_params_cpn')
        return promise.then(response => response.data)
    },

    saveExamensPhysiquesCpn(data) {
        const promise = Api().post('/save_exam_physiques_elements', data)
        return promise.then(response => response.data)
    },

    saveHypotheseDiagnosticCpn(data) {
        const promise = Api().post('/save_hypothese_diagnostic_cpn', data)
        return promise.then(response => response.data)
    },
}